import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [fullname, setFullname] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedFullname = localStorage.getItem('fullname');
    if (storedToken && storedFullname) {
      setToken(storedToken);
      setFullname(storedFullname);
      setIsAuthenticated(true);
    }
  }, []);

  const login = (newToken, newFullname) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('fullname', newFullname);
    setToken(newToken);
    setFullname(newFullname);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('fullname');
    setToken(null);
    setFullname(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, fullname, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};